import { updatePdlPage, updatePdlUser, triggerOmnitureEvent } from '@bingads-webui-campaign/global-app-init';

export const UP_WIZARD_PAGE = {
  GOAL_OPTIONS: {
    pageId: 'goal_options_page',
    pageTitle: 'Choose your advertising goals',
  },
  SMART_PAGE_SIGNUP: {
    pageId: 'smart_page_signup',
    pageTitle: 'Welcome to Smart Pages!',
  },
  SMART_PAGE_EDITOR: {
    pageId: 'smart_page_editor',
    pageTitle: 'Edit your website',
  },
  SMART_PAGE_CUSTOM_DOMAIN: {
    pageId: 'smart_page_custom_domain',
    pageTitle: 'Select your website address',
  },
  REVIEW_AND_CONFIRM: {
    pageId: 'review_and_confirm_page',
    pageTitle: 'Review your ad campaign details',
  },
};

export function omniturePageLoad({
  campaignId,
  pageId,
  pageTitle,
  isSignUp = false,
  signUpPrefix = 'unified_products_signup_step_',
}) {
  const navLevel3 = isSignUp ? `${signUpPrefix}${pageId}` : pageId;
  updatePdlPage({
    campaignId,
    navLevel3,
    navLevel3Title: pageTitle,
  });
}

export const omnitureAccountCreated = ({
  serverContext,
  pageId,
  pageTitle,
}) => {
  const {
    CurrentAccount,
  } = serverContext;

  updatePdlUser(serverContext);

  triggerOmnitureEvent({
    navLevel3: pageId,
    navLevel3Title: pageTitle,
    user: {
      aid: CurrentAccount.Id,
      cid: CurrentAccount.AdvertiserCustomerID,
      accountMode: CurrentAccount.AccountMode,
    },
  });
};
